// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ-styles-module--faq--1UCoE","item":"FAQ-styles-module--item--2PHCD","header":"FAQ-styles-module--header--26CLj","content":"FAQ-styles-module--content--2aZd0"};